import { defineMessages } from 'react-intl';

const messages = defineMessages({
  unitsCount: {
    id: 'App.ManageBuildingsV2.UnitsCount',
    defaultMessage: '# Units',
  },
  countName: {
    id: 'App.ManageBuildingsV2.CountName',
    defaultMessage: 'Buildings',
  },
  emptyState: {
    id: 'App.ManageBuildingsV2.EmptyState',
    defaultMessage: 'No buildings found',
  },
  loadError: {
    id: 'App.ManageBuildingsV2.LoadError',
    defaultMessage: 'Failed to load buildings. Please try again.',
  },
  editBuilding: {
    id: 'App.ManageBuildingsV2.EditBuilding',
    defaultMessage: 'Edit Building',
  },
  saveChanges: {
    id: 'App.ManageBuildingsV2.SaveChanges',
    defaultMessage: 'Save Changes',
  },
  discardChangesTitle: {
    id: 'App.ManageBuildingsV2.DiscardChangesTitle',
    defaultMessage: 'Discard changes?',
  },
  discardChangesBody: {
    id: 'App.ManageBuildingsV2.DiscardChangesBody',
    defaultMessage: 'Your unsaved changes will be lost.',
  },
  noPermissionTooltip: {
    id: 'App.ManageBuildingsV2.NoPermissionTooltip',
    defaultMessage: 'You do not have permission to edit buildings',
  },
  streetAddress: {
    id: 'App.ManageBuildingsV2.StreetAddress',
    defaultMessage: 'Street Address',
  },
  city: {
    id: 'App.ManageBuildingsV2.City',
    defaultMessage: 'City',
  },
  state: {
    id: 'App.ManageBuildingsV2.State',
    defaultMessage: 'State',
  },
  zipCode: {
    id: 'App.ManageBuildingsV2.ZipCode',
    defaultMessage: 'Zip Code / Postal Code',
  },
  errorAlphanumeric: {
    id: 'App.ManageBuildingsV2.ErrorAlphanumeric',
    defaultMessage: 'Letters and numbers only',
  },
});

export default messages;
